<template>
    <div>
        <div v-show="showReport" class="online_overlay" @click="toggleReport"></div>
        <transition name="slide-fade">
            <div v-show="showReport" class="online_report">
<!--                <div class="report_header flex aic jcc">-->
<!--                    <div class="close" @click="close"></div>-->
<!--                    <div class="flex aic jcc">-->
<!--                        <span class="mr10 fs14 color_999">就诊时间:</span>-->
<!--                        <el-date-picker-->
<!--                                v-model="dateStart"-->
<!--                                type="date"-->
<!--                                size="mini"-->
<!--                                style="width: 150px !important;"-->
<!--                                placeholder="选择日期">-->
<!--                        </el-date-picker>-->
<!--                        <span class="ml10 mr10 fs14 color_999">至</span>-->
<!--                        <el-date-picker-->
<!--                                v-model="dateEnd"-->
<!--                                type="date"-->
<!--                                size="mini"-->
<!--                                style="width: 150px !important;"-->
<!--                                placeholder="选择日期">-->
<!--                        </el-date-picker>-->
<!--                        <el-button type="primary" size="mini" class="ml30">查询</el-button>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="report_body flex">
                    <div class="left">
                        <vue-scroll :ops="ops">

                            <!-- 诊疗记录 -->
                            <div class="report_item" v-for="(item,index) in totalList" :key="item.key" @click="setIndex(item.key)"
                                 :class="{'clicked': item.key == indexx }"
                            >
                                <template v-if="item.type == 'line'">
                                    <div class="flex aic fs14 pl10 pr10" style="justify-content: space-between;">
                                        <div>{{item.visittime}}</div>
                                        <div>{{item.patname}}</div>
                                        <div>{{item.patsex | sexFilter}}</div>
                                        <div>{{item.patage}}岁</div>
                                    </div>
                                    <div class="flex aic fs14 mt10 pl10">
                                        <div>接诊医生:</div>
                                        <div>{{item.docname || '普通号'}}</div>
                                    </div>
                                    <div class="flex aic fs14 mt10 pl10">
                                        <div>科室:</div>
                                        <div>{{item.deptname}}</div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="flex aic fs14 pl10 pr10" style="justify-content: space-between;">
                                        <div style="color: red;">网</div>
                                        <div>{{item.outpatientTime | replaceTime(item.modifyTime)}}</div>
                                        <div>{{item.compatName}}</div>
                                        <div>{{item.compatGender | sexBookFilter}}</div>
                                        <div>{{item.compatAge}}岁</div>
                                    </div>
                                    <div class="flex aic fs14 mt10 pl10">
                                        <div>接诊医生:</div>
                                        <div>{{item.bookDocName || '普通号'}}</div>
                                    </div>
                                    <div class="flex aic fs14 mt10 pl10">
                                        <div>科室:</div>
                                        <div>{{item.bookDeptName}}</div>
                                    </div>
                                </template>
                            </div>


                            <!-- 线下就诊记录 -->
<!--                            <div class="report_item" v-for="(item,index) in lineList" :key="'line-' + index" @click="setIndex(`line-${index}`)"-->
<!--                             :class="{'clicked': `line-${index}` == indexx }"-->
<!--                            >-->
<!--                                <div class="flex aic fs14 pl10 pr10" style="justify-content: space-between;">-->
<!--                                    <div>{{item.visittime}}</div>-->
<!--                                    <div>{{item.patname}}</div>-->
<!--                                    <div>{{item.patsex | sexFilter}}</div>-->
<!--                                    <div>{{item.patage}}岁</div>-->
<!--                                </div>-->
<!--                                <div class="flex aic fs14 mt10 pl10">-->
<!--                                    <div>接诊医生:</div>-->
<!--                                    <div>{{item.docname || '普通号'}}</div>-->
<!--                                </div>-->
<!--                                <div class="flex aic fs14 mt10 pl10">-->
<!--                                    <div>科室:</div>-->
<!--                                    <div>{{item.deptname}}</div>-->
<!--                                </div>-->
<!--                            </div>-->

                            <!-- 线上就诊记录 -->
<!--                            <div class="report_item" v-for="(item,index) in onLineList" :key="'online-' + index" @click="setIndex(`online-${index}`)"-->
<!--                                 :class="{'clicked': `online-${index}` == indexx}"-->
<!--                            >-->
<!--                                <div class="flex aic fs14 pl10 pr10" style="justify-content: space-between;">-->
<!--                                    <div>{{item.outpatientTime | replaceTime(item.modifyTime)}}</div>-->
<!--                                    <div>{{item.compatName}}</div>-->
<!--                                    <div>{{item.compatGender | sexBookFilter}}</div>-->
<!--                                    <div>{{item.compatAge}}岁</div>-->
<!--                                </div>-->
<!--                                <div class="flex aic fs14 mt10 pl10">-->
<!--                                    <div>接诊医生:</div>-->
<!--                                    <div>{{item.bookDocName || '普通号'}}</div>-->
<!--                                </div>-->
<!--                                <div class="flex aic fs14 mt10 pl10">-->
<!--                                    <div>科室:</div>-->
<!--                                    <div>{{item.bookDeptName}}</div>-->
<!--                                </div>-->
<!--                            </div>-->

                        </vue-scroll>
                    </div>
                    <div class="right_">
                        <div class="tab flex aic pl30">
                            <el-radio-group v-model="tabPosition" size="mini">
                                <el-radio-button label="1">诊疗记录</el-radio-button>
                                <el-radio-button label="2">处方记录</el-radio-button>
                            </el-radio-group>
                        </div>
                        <div class="body_ pl10">
                            <vue-scroll :ops="ops">
                                <!-- 诊断记录 -->
                                <div v-show="tab && index">
                                    <div>
                                        <div class="fs16 flex">初步诊断:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.diagnosis || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">处理措施:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.measures || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">心理情况:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.inmind || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">经济情况:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.economics || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">社会情况:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.ambient || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">个性评估:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.personality || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">弱势群体:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.disadvantaged || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">主诉:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.chief || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">现病史:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.present || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">既往史:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.past || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">家族史:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.family || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">过敏史:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.allergy || '暂无'}}</div>
                                    </div>
                                    <div class="mt5">
                                        <div class="fs16 flex">月经史:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.menstrual || '暂无'}}</div>
                                    </div>
                                    <div style="width: 95%;height: 100px;margin:10px 2.5%;border: 1px solid #999999;border-radius: 10px;">
                                        <div class="mt5 pl5">
                                            体格检查:
                                        </div>
                                        <div class="flex aic pl10 pr10" style="justify-content: space-between;">
                                            <div class="flex fs14 color_999">
                                                <div>血压:</div>
                                                <div>{{orderDetail.pressure || '-'}}mmHg</div>
                                            </div>
                                            <div class="flex fs14 color_999">
                                                <div>脉搏:</div>
                                                <div>{{orderDetail.pulse || '-'}}次/分</div>
                                            </div>
                                        </div>
                                        <div class="flex aic pl10 pr10" style="justify-content: space-between;">
                                            <div class="flex fs14 color_999">
                                                <div>体重:</div>
                                                <div>{{orderDetail.weight || '-'}}Kg</div>
                                            </div>
                                            <div class="flex fs14 color_999">
                                                <div>疼痛评分:</div>
                                                <div>{{orderDetail.pain || '-'}}分</div>
                                            </div>
                                        </div>
                                        <div class="flex aic pl10 pr10" style="justify-content: space-between;">
                                            <div class="flex fs14 color_999">
                                                <div>跌倒评分:</div>
                                                <div>{{orderDetail.fall || '-'}}分</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt5 mb30">
                                        <div class="fs16 flex">辅助检查:</div>
                                        <div class="fs14 color_999 flex">{{orderDetail.auxiliary || '暂无'}}</div>
                                    </div>
                                </div>

                                <!-- 处方记录 -->
                                <div v-show="!tab && index">
                                    <!-- 线下 -->
                                    <template v-if="type == 'line'">
                                        <div class="xiyao pl5 pr5 pt5 pb5" v-for="(cost,index) in lineBizList" :key="'cost' + index">
                                            <div class="flex aic" style="justify-content: space-between;">
                                                <div class="color_999 fs14">处方编号：{{cost.recipelno || '暂无'}}</div>
                                                <div class="color_999 fs14">开方日期：{{cost.recipeldate || '暂无'}}</div>
                                            </div>
                                            <div class="fs16 mt5 mb5">{{cost.recipeltype | filterType}}</div>
                                            <div class="fs14">初步诊断：{{cost.diagnosis}}</div>
                                            <div class="fs12 detail mt10" @click="showBizDetail(cost,'line')">查看详情>></div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="xiyao pl5 pr5 pt5 pb5" v-for="(cost,index) in onLineBizList" :key="'cost_' + index" @click="showBizDetail(cost,'online')">
                                            <div class="flex aic" style="justify-content: space-between;">
                                                <div class="color_999 fs14">处方编号：{{cost.orderNo || '暂无'}}</div>
                                                <div class="color_999 fs14">开方日期：{{cost.createDate | filterTime}}</div>
                                            </div>
                                            <div class="fs16 mt5 mb5">{{cost.orderType == 'WESTERN_RECIPE' ? '西药方' : '中药方'}}</div>
                                            <div class="fs14">初步诊断：{{cost.diagnosis}}</div>
                                            <div class="fs12 detail mt10" @click="showBizDetail(cost,'online')">查看详情>></div>
                                        </div>
                                    </template>
                                </div>
                            </vue-scroll>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <wlmz-biz-detail ref="bizDetail"></wlmz-biz-detail>
    </div>
</template>

<script>
    import WlmzBizDetail from './wlmz-biz-detail'
    import {isEmpty,timeFormat} from "../../lib/utils"
    export default {
        name: "wlmz-online-report",
        props:{
            lineList:{
                type:Array,
                defalut:() => {
                    return []
                }
            },
            onLineList:{
                type:Array,
                defalut:() => {
                    return []
                }
            },
            totalList:{
                type:Array,
                defalut:() => {
                    return []
                }
            }
        },
        components:{WlmzBizDetail},
        data(){
            return {
                showReport:false,
                dateStart:'',
                dateEnd:'',
                tabPosition:'1',
                ops:{
                    bar: {
                        background:"#999999"
                    }
                },
                tab:true,
                index:'', //列表点击的index
                indexx:'',
                type:'', //列表点击的type
                orderDetail:{},
                lineBizList:[],
                onLineBizList:[]
            }
        },
        watch:{
            showReport(){
                let body = document.getElementsByTagName('body')[0];
                if(this.showReport){
                    body.classList.add("body_hidden");
                }else{
                    body.classList.remove("body_hidden");
                }
            },
            async tabPosition(){
                if(this.tabPosition == 1){
                    //线上
                    if(this.type != 'line'){
                        let index = this.index.split('-')[1];
                        let orderDetail = this.onLineList[index];

                        let obj = await this.queryOnLineReport(orderDetail.id);
                        this.orderDetail = Object.assign({},orderDetail,obj);

                    }
                    this.tab = true;
                }else{
                    if(!isEmpty(this.orderDetail)){
                        if(this.type == 'line'){
                            await this.queryLineOrdrtCost();
                        }else{
                            let index = this.index.split('-')[1];
                            let orderDetail = this.onLineList[index];
                            await this.queryOnLinebiz(orderDetail.id);
                        }
                    }
                    this.tab = false;
                }
            },
            async index(){
                let type = this.index.split('-')[0];
                let index = this.index.split('-')[1];
                this.type =type;
                //线下
                if(type == 'line'){
                    this.orderDetail = this.lineList[index];
                    if(!this.tab){
                        await this.queryLineOrdrtCost();
                    }
                }else{
                    let orderDetail = this.onLineList[index];
                    if(!this.tab){
                        await this.queryOnLinebiz(orderDetail.id);
                    }else{
                        //查询就诊记录

                       let obj = await this.queryOnLineReport(orderDetail.id);
                       this.orderDetail = Object.assign({},this.onLineList[index],obj);

                    }
                }

            }
        },
        filters:{
            sexFilter(v){
                if(v == '1'){
                    return '男'
                }else if(v == '2'){
                    return '女'
                }else{
                    return '其他'
                }
            },
            sexBookFilter(v){
                if(v == 'M'){
                    return '男'
                }else if(v == 'F' || v == 'N'){
                    return '女'
                }else{
                    return '其他'
                }
            },
            filterType(f){
                if(f == '2'){
                    return '西药方'
                }else{
                    return '中药方'
                }
            },
            replaceTime(v,v1){
                return timeFormat(v1, '%Y-%m-%d');
            },
            filterTime(time){
                if(!time) return '暂无'
                return timeFormat(time, '%Y-%m-%d');
            }
        },
        methods:{
            reset(){
                this.orderDetail = {};
                this.lineBizList = [];
                this.onLineBizList = [];
                this.tabPosition = '1';
                this.index = '';
                this.indexx = '';
            },
            setIndex(i){
              this.index = i  ;
              this.indexx = i ;
            },
            show(){
                this.showReport = true;
            },
            toggleReport(){
                this.showReport = false;
            },
            close(){
                this.showReport = false;
            },
            //查询线下处方列表
            async queryLineOrdrtCost(){
                const {code,list} = await this.$http('smarthos.yygh.ApiHosPayService.queryOrdrtCostList',{
                    orgid:this.orderDetail.orgid,
                    orderid:this.orderDetail.orderid
                })
                if(code == 0){
                    this.lineBizList = list;
                }else{
                    this.lineBizList = [];
                }
            },
            //查询线上处方列表
            async queryOnLinebiz(id){
                const {code,list} = await this.$http('smarthos.recipe.order.list.biz',{
                    bizId:id,//'10001827',//this.orderDetail.id
                })
                if(code == 0){

                    this.onLineBizList = list;
                }else{
                    this.onLineBizList = [];
                }
            },
            //查询线上就诊记录
            async queryOnLineReport(id){
                const {code,obj = {}} = await this.$http('smarthos.online.outpatient.medical.info',{
                    id:id,//this.orderDetail.id
                })
                if(code == 0){
                    let tmp = {}
                    tmp.diagnosis = obj.diagnosisName || undefined;
                    tmp.measures = obj.handleContent || undefined;
                    tmp.inmind = obj.sleepStatus || undefined;
                    tmp.economics = obj.economicCondition || undefined;
                    tmp.ambient = obj.socialEnvironment || undefined;
                    tmp.personality = obj.personalityAppraisal || undefined;
                    tmp.disadvantaged = obj.disadvantagedType || undefined;
                    tmp.chief = obj.diseaseDescription || undefined;
                    tmp.present = obj.nowHistory || undefined;
                    tmp.past = obj.pastHistory || undefined;
                    tmp.family = obj.familyHistory || undefined;
                    tmp.allergy = obj.allergyHistory || undefined;
                    tmp.menstrual = obj.mensesHistroy || undefined;
                    tmp.pressure = obj.bloodPressure || undefined;
                    tmp.pulse = obj.pulse || undefined;
                    tmp.weight = obj.weight || undefined;
                    tmp.pain = obj.painScore || undefined;
                    tmp.fall = obj.fallScore || undefined;
                    tmp.auxiliary = obj.supplementaryExamination || undefined;
                    return tmp
                }else{
                    return {}
                }
            },
            //显示处方详情  type : line 线下 online 线上
            async showBizDetail(item,type){
                let list = [];
                if(type == 'line'){
                  list = await this.queryBizDetail(item);
                }else{
                    //修改一下 数据结构和上面保持一致
                  list = this.replaceJson(item.drugList);
                }
                this.$refs.bizDetail.show(list);
            },
            async queryBizDetail(item){
                let loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
                const {code,list} = await this.$http('smarthos.yygh.ApiHosPayService.queryOrdrtCostInfo',{
                    "orgid":loginInfo.doc.bookHosId || '01001',
                    "recipelno":item.recipelno
                })
                if(code == '0'){
                    return list
                }
                return []
            },
            replaceJson(json= []){
              let list = json.map( r => {
                  return {
                      "itemname":r.drugName,
                      "plasters":r.amount,
                      "price":r.drugTotalPrice/100,
                      "spec":r.drugSpecification,
                      "usage":`${r.admission}，${r.frequencyName}，每次${r.dosage}${r.dosageUnit}`
                  }
              })
              return list;
            }
        },
        created() {

        }


    }
</script>

<style lang="scss" scoped>
    .online_overlay{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        z-index:1001;
    }

    .online_report{
        position: fixed;
        width: 45%;
        height: 100%;
        z-index: 1002;
        background-color: #fff;
        top:0;
        right: 0;
        .report_header{
            position: relative;
            height: 15%;
            width: 100%;
            .close{
                position: absolute;
                left: 0;
                top: 0;
                width: 30px;
                height: 30px;
                background: red;
                cursor:pointer;
            }
        }
        .report_body{
            position: relative;
            height: 100%;
            width: 100%;
            .left{
                position: relative;
                height: 100%;
                width: 40%;
                border-top: 1px solid #999999;
                border-right: 1px solid #999999;
                .report_item{
                    width:95%;
                    margin: 10px 2.5%;
                    height: 120px;
                    border: 1px solid #999999;
                    border-radius: 10px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    cursor: pointer;
                }
            }
            .right_{
                position: relative;
                height: 100%;
                width: 60%;
                border-top: 1px solid #999999;
                .tab{
                    height: 10%;
                    width: 100%;
                }
                .body_{
                    height: 90%;
                    width: 100%;
                }
            }
        }
    }

    .xiyao,.zhongyao{
        width: 95%;
        margin: 10px 2.5%;
        border: 1px solid #999999;
        cursor: pointer;
    }

    .xiyaoItem{
        border-bottom: 1px dotted #999999;
    }

    .clicked{
        border-color: #409EFF !important;
    }

    .detail{
        text-align: right;
        color: #409EFF;
    }

</style>